import * as React from 'react'
import { useState, useLayoutEffect } from 'react'
import styled from 'styled-components'
import { useCookies } from 'react-cookie'
import Layout from '../components/layout'
import { Link, navigate } from 'gatsby'
import { bundleImage } from '../contents/imageBundle'
import type { bundledImageObject } from '../contents/imageBundle'
import { expandCompressedFont, fontCompress } from '../components/globalStyles'
import { KString } from '../components/kerning'
import SEO from '../components/seo'

type objectOrderList = Array<{
  quantity: number;
  price: 0
} & bundledImageObject>;

const Order: React.FC = () => {
  const [cookie, setCookie, removeCookie] = useCookies(['totossawcollectionorder'])
  const objectData = bundleImage()

  let totalPrice = 0
  let totalCount = 0

  if (!cookie.totossawcollectionorder) {
    return (
      <Layout>
        <SEO title={'ORDER'} />
        <OrderView>
          <header>
            <Link to={'./'} onClick={()=>history?.back()}>
              <div className={'spacer'}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39">
                  <polygon points="19.3 39 20 38.29 1.9 20 39 20 39 19 1.9 19 20 0.71 19.3 0 0 19.5 19.3 39"/>
                </svg>
              </div>
            </Link>
            <p>
              <span className={'str'}>ORDER</span>
            </p>
          </header>
          <p>Not Found</p>
          <p>total : {totalCount} {totalPrice} JPY</p>
        </OrderView>
      </Layout>
    )
  }
  const objectlist: bundledImageObject[] = cookie.totossawcollectionorder.map((order: any) => {
    return objectData.find((o: any) => order == o.objectName)
  })
  
  const orderedObjectList: objectOrderList = [
    ...new Set(cookie.totossawcollectionorder)
  ].map(u => {
    let count = 0
    const newObj: bundledImageObject = objectlist.find((o: any) => u == o.objectName)!
    objectlist.forEach(l => {
      if (l.objectName == u) {
        count++
      }
    })
    return {
      quantity: count,
      price: 0,
      ...newObj
    }
  })
  const [complete, setComplete] = useState(false)
  const [email, inputEmail] = useState('')
  const [isEmailError, setEmailError] = useState(false)
  const handleRemoveCookie = () => {
    if (!isEmailError && email !== '') {
      navigate('/ordercomp')
    }
  }
  
  const submit = () => {
    if (document.querySelector('form')) {
      document.querySelector('form')?.submit()
    }
  }
  const [loaded, setLoaded] = useState(false)
  useLayoutEffect(() => {
    if (window !== undefined) {
      setTimeout(() => {
        setLoaded(true)
      },400)
    }
  },[])

  return (
    <Layout>
      <SEO title={'ORDER'} />
      <OrderView>
        <header>
          <Link to={'./'} onClick={()=>history?.back()}>
            <div className={'spacer'}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39">
                <polygon points="19.3 39 20 38.29 1.9 20 39 20 39 19 1.9 19 20 0.71 19.3 0 0 19.5 19.3 39"/>
              </svg>
            </div>
          </Link>
          <p>
            <span className={'str'}>
              ORDER
            </span>
          </p>
        </header>
        <p>以下の装身具のオーダーを受け付けます。</p>
        <div className={'orderedObjectList'}>
          {orderedObjectList ?
            <>
              <ul>
                {orderedObjectList.map(o => {
                  totalPrice += o.quantity * o.price
                  totalCount += o.quantity
                  return (
                    <li key={o.id}>
                      <img src={o.publicURL} height={120} />
                      <p>{o.objectName}</p>
                      <p className='PC'>Quantity: {o.quantity.toLocaleString()}</p>
                      <div className='mobile'>
                        <p>Quantity: {o.quantity.toLocaleString()}</p>
                      </div>
                    </li>
                  )
                })}
              </ul>
              <p>
                <span>
                  Total: {totalCount}
                </span> 
              </p>
              <form
                action="https://docs.google.com/forms/u/0/d/e/1FAIpQLSdKLxdwNJuZvm6Ym_7PSFNVutibIWbvkmIS_EJmLyxzIeFmZw/formResponse"
                method="POST"
                target="hidden_iframe"
                className={'orderform'}
              >
                <div className={'email_input'}>
                  <div>
                    <p>
                      Your contact address(e-mail)
                    </p>
                    <p>
                      <KString>
                        ご記入いただいたご連絡先に、ダウンロードリンクをお送りいたします。
                      </KString>
                    </p>
                  </div>
                  <EmailInput 
                    type={'text'} 
                    name={'entry.843554269'} 
                    className={'Email'} 
                    placeholder={'Enter your email address'} 
                    onChange={(e) => {
                      inputEmail(e.target.value)
                    }}
                    value={email}
                    isInputErr={isEmailError}
                  />
                </div>
                <input type={'hidden'} name={'entry.325224457'} className={'order'} value={`"${cookie.totossawcollectionorder}"`}></input>
                {loaded &&
                <div className={'submit_button_area'}>
                  <button
                    onClick={
                      (e) => {
                        if ((/[\w\-._]+@[\w\-._]+\.[A-Za-z]+/).test(email)) {
                          setEmailError(false)
                          console.log('submit')
                          submit()
                        } else {
                          setEmailError(true)
                          return false
                        }
                      }
                    }
                    type={'button'}
                  >
                    <span>ORDER</span>
                  </button>
                </div>
                }
                <div className='bottom_spacer' />
              </form>
              <HiddenWindow
                name="hidden_iframe"
                id="hidden_iframe"
                onLoad={handleRemoveCookie}
              />
            </>
            :<p></p>}
        </div>
      </OrderView>
    </Layout>
  )
}

type errableInput = {
  isInputErr: boolean
}



export default Order

const OrderView = styled.div`
  min-height: calc(100vh - 99px);
  & > header{
    position: sticky;
    top: 60px;
    z-index: 1;
    background: #ffffff;
    height: 60px;
    box-sizing: border-box;
    border-bottom: 1px solid #040000;
    display: grid;
    grid-template-columns: 86px 1fr;
    padding: 0 0 0 0;
    a{
      div.spacer{
        border-right: 1px solid #040000;
        svg{
          width: 40px;
          height: 59px;
          object-fit: contain;
          margin: auto;
          display: block;
          fill: #040000;
        }
      }
      &:hover{
        div.spacer{
          background: #040000;
          svg{
            fill: #ffffff;
          }
        }
      }
    }
    p{
      ${expandCompressedFont}
      padding: 14px 21px 14px 19px;
      color: #040000;
      span{
        ${fontCompress}
        display: block;
        font-size: 20px;
      }
    }
  }
  & > p{
    padding: 33px 50px 36px 50px;
    border-bottom: 1px solid #040000;
    box-sizing: border-box;
  }
  & > div.orderedObjectList{
    ul{
      li{
        display: grid;
        grid-template-columns: 188px 126px 1fr 315px;
        padding: 30px 40px 29px 40px;
        box-sizing: border-box;
        border-bottom: 1px solid #040000;
        position: relative;
        img{
          width: 100px;
          height: 120px;
          object-fit: contain;
        }
        p{
          position: relative;
          top: 43px;
          ${fontCompress}
          height: 30px;
          span{
            display: block;
          }
        }
        div.mobile{
          display: none;
        }
      }
    }
    & > p{
      padding: 24px 50px 25px 51px;
      border-bottom: 1px solid #040000;
      box-sizing: border-box;
      font-size: 20px;
      span+span{
        margin: 0 0 0 35px;
      }
    }
    & > form{
      div.email_input{
        display: grid;
        grid-template-columns: 343px 1fr;
        padding: 25px 40px 23px 40px;
        & > div{
          p{
            font-size: 20px;
            & + p{
              font-size: 12px;
              line-height: 21px;
            }
          }
        }
        input{
          display: block;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          border: none;
          border-radius: 0;
          border-bottom: 1px solid #040000; 
          height: 33px;
          padding: 0 0 11px 2px;
          ${fontCompress}
          font-size: 20px;
          ::placeholder {
            color: #cccccc;
            font-size: 20px;
          }
          &:focus {
            border: none;
            background: #ffffff;
            outline: 0;
            border-bottom: 1px solid #040000;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
          }
        }
      }
      & > div.submit_button_area{
        display: flex;
        justify-content: flex-end;
        border-top: 1px solid #040000;
        border-bottom: 1px solid #040000;
        button{
          display: block;
          border: none;
          border-left: 1px solid #040000;
          width: 216px;
          height: 60px;
          background: #040000;
          cursor: pointer;
          span{
            ${fontCompress}
            color: #ffffff;
            display: block;
            transform-origin: 50% 50%;
            width: 100%;
            text-align: center;
            font-size: 20px;
            transform: scale(0.75, 1);
            padding: 0 2px 0 0;
          }
          &:hover{
            background: #ffffff;
            span{
              color: #040000;
            }
          }
        }
      }
      div.bottom_spacer{
        height: 60px;
      }
    }
  }
  @media screen and (max-width:768px){
    min-height: calc(100vh - 91px);
    & > header{
      a{
        &:hover{
          div.spacer{
            background: #ffffff;
            svg{
              fill: #040000;
            }
          }
        }
      }
    }
    & > p{
      padding:15px 25px 15px 25px;
    }
    & > div.orderedObjectList{
      ul{
        li{
          grid-template-columns: 1fr 100px 100px 0;
          padding: 20px 0 20px 15px;
          p{
            &.PC{
              display: none;
            }
          }
          div.mobile{
            display: block;
            position: relative;
            top: -2px;
          }
        }
      }
      & > p{
        padding: 10px 50px 16px 25px;
      }
      & > form{
        div.email_input{
          grid-template-columns: 1fr;
          padding: 14px 20px 23px 20px;
          & > div{
            p{
              font-size: 16px;
              & + p{
                font-size: 12px;
                line-height: 13px;
              }
            }
          }
          input{
            height: 57px;
            margin: 5px 0 0 0;
            padding: 0 0 0 0;
            ${fontCompress}
            font-size: 20px;
            width: 125%;
          }
        }
        & > div.submit_button_area{
          margin: 16px 0 0 0;
          border-bottom: 1px solid #ffffff;
          button{
            width: 100%;
            border-left: none;
            span{
              width: 99%;
            }
            &:hover{
              background: #040000;
              span{
                color: #ffffff;
              }
            }
          }
        }
      }
    }
    
  }
`

const RestButton = styled.span`
  padding: 10px;
  border: 1px solid #040000;
  display: inline-block;
  cursor: pointer;
`

const HiddenWindow = styled.iframe`
  height: 0;
  width: 0;
  display: none;
`


const EmailInput = styled.input<errableInput>`
  border-color: ${(props) => props.isInputErr ? `#f40000` : `#040000`} !important;
`